import axios from 'axios'
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { isMobileOnly } from 'react-device-detect'

import './PresentationControllerPage.css'

import { FirestoreRepository } from '../../../commons/repository/FirestoreRepository'
import PresentationController, {
  ControllerType
} from '../../components/organisms/PresentationController/PresentationController'
import * as QuizPhase from '../../../commons/QuizPhase'
import {
  RECEIVE_CHANGE_STATUS,
  FETCH_PROJECT,
  FETCH_RANKING,
  WAIT_WEBSOCKET,
  CHANGE_REALTIME_ANSWER_CHOICE,
  UPDATE_REALTIME_ANSWER_CHOICE
} from '../../actions/presentationActions'
import { QuizType, QuestionType } from '../../../commons/EditorStatus'
import { getParams, getStorage, setStorage, removeStorage } from '../../../commons/utils'
import Spinner from '../../components/atoms/Spinner/Spinner'

const END_TIME_KEY = 'presentation_controller_end_time'

const changePresentationStatus = (projectId, params) => {
  return axios.post(`/api/v1/organizers/projects/${projectId}/presentations/change`, params)
}

class PresentationControllerPage extends PureComponent {
  constructor(params) {
    super(params)
    this.state = {
      timeout: null,
      isWatchingFirestore: false
    }
  }

  componentDidMount() {
    this.props.fetchProject(getParams().env)
  }

  async next(type, index, phase, questionType) {
    this.props.waitWebsocket()

    switch (type) {
      case QuizType.NOTIFICATION.value:
        await changePresentationStatus(this.props.project.id, { type: QuizType.FIRSTPAGE.value, phase: 0, index: 0 })
        break

      case QuizType.FIRSTPAGE.value:
        await changePresentationStatus(this.props.project.id, { type: QuizType.QUESTION.value, phase: 0, index: 0 })
        break

      case QuizType.QUESTION.value:
        this.nextPhase(index, phase, questionType)
        break

      case QuizType.RANKING.value:
        this.nextRanking(index)
        break
    }
  }

  async back(type, index, phase) {
    this.props.waitWebsocket()

    switch (type) {
      case QuizType.NOTIFICATION.value:
        break

      case QuizType.FIRSTPAGE.value:
        await changePresentationStatus(this.props.project.id, { type: QuizType.NOTIFICATION.value, phase: 0, index: 0 })
        break

      case QuizType.QUESTION.value:
        this.backPhase(index, phase)
        break

      case QuizType.RANKING.value:
        this.backRanking(index)
        break
    }
  }

  async nextPhase(index, phase, questionType) {
    if (questionType === QuestionType.REALTIME.value && phase === QuizPhase.DEMONSTORATION) {
      this.props.updateAnswerChoice()
    }
    const { newType, newIndex, newPhase } = QuizPhase.nextPhase(index, phase, this.props.project.questions.length)
    await changePresentationStatus(this.props.project.id, { type: newType, phase: newPhase, index: newIndex })
  }

  async backPhase(index, phase) {
    const { newType, newIndex, newPhase } = QuizPhase.backPhase(index, phase)
    await changePresentationStatus(this.props.project.id, { type: newType, phase: newPhase, index: newIndex })
  }

  async nextRanking(index) {
    const { ranking } = this.props
    if (ranking.length < index + 1) {
      await changePresentationStatus(this.props.project.id, { type: QuizType.COMPLETE.value, phase: 0, index: index })
    } else {
      await changePresentationStatus(this.props.project.id, {
        type: QuizType.RANKING.value,
        phase: 0,
        index: index + 1,
        name: ranking[index].name,
        rank: ranking[index].rank
      })
    }
  }

  // 1位の時のみ送るため、backではnameを送る必要がない
  async backRanking(index) {
    const newIndex = index === 0 ? 0 : index - 1
    await changePresentationStatus(this.props.project.id, {
      type: QuizType.RANKING.value,
      phase: 0,
      index: newIndex,
      name
    })
  }

  render() {
    const {
      project,
      ranking,
      recieveChangeStatus,
      fetchRanking,
      index,
      phase,
      type,
      isLoading,
      isRankingFetching,
      isRankingFetched,
      isContainerPage,
      changeAnswerChoice
    } = this.props
    const nowQuestion = project.questions[index]
    if (!project.id) {
      return (
        <div styleName="spinner">
          <Spinner />
        </div>
      )
    }

    if (!this.state.isWatchingFirestore && !isContainerPage) {
      const firestoreRepository = new FirestoreRepository()
      firestoreRepository.watchPresentationQuizStatus(project.room_id, data => {
        recieveChangeStatus(data)
      })
      this.setState({
        isWatchingFirestore: true
      })
    }

    if (type === QuizType.QUESTION.value && phase === QuizPhase.START && !this.state.timeout) {
      if (!getStorage(END_TIME_KEY)) {
        setStorage(END_TIME_KEY, Date.now() / 1000 + (nowQuestion ? nowQuestion.limit_time : 0))
      }

      const timeout = setTimeout(() => {
        if (type === QuizType.QUESTION.value && phase === QuizPhase.START) {
          this.next(type, index, phase)
        }
      }, getStorage(END_TIME_KEY) * 1000 - Date.now())
      this.setState({ timeout })
    }

    if (phase !== QuizPhase.START) {
      removeStorage(END_TIME_KEY)
      clearTimeout(this.state.timeout)
      this.setState({ timeout: null })
    }

    // ランキング情報の取得
    if (type === QuizType.RANKING.value && !isRankingFetching && !isRankingFetched) {
      fetchRanking({ projectId: project.id })
    }

    let controllerType = isMobileOnly ? ControllerType.NORMAL_FOR_SMARTPHONE : ControllerType.NORMAL_FOR_DESKTOP
    if (isContainerPage) {
      controllerType = isMobileOnly ? ControllerType.HEADLESS_FOR_SMARTPHONE : ControllerType.HEADLESS_FOR_TABLET
    }

    //QuizTypeを取得
    const questionType = nowQuestion ? nowQuestion.question_type : null

    return (
      <div styleName="container">
        <PresentationController
          index={index}
          phase={phase}
          type={type}
          questionType={questionType}
          isLoading={isLoading}
          controllerType={controllerType}
          rankingCount={ranking.length}
          handleBackButtonClick={() => this.back(type, index, phase)}
          handleNextButtonClick={() => this.next(type, index, phase, questionType)}
          nowQuestion={nowQuestion}
          onChangeAnswerChoice={changeAnswerChoice}
        />
      </div>
    )
  }
}

PresentationControllerPage.propTypes = {
  // Socket
  index: PropTypes.number.isRequired,
  phase: PropTypes.number.isRequired,
  type: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  // API
  project: PropTypes.object,
  ranking: PropTypes.array,
  isRankingFetching: PropTypes.bool.isRequired,
  isRankingFetched: PropTypes.bool.isRequired,
  // dispatch
  waitWebsocket: PropTypes.func.isRequired,
  recieveChangeStatus: PropTypes.func.isRequired,
  fetchProject: PropTypes.func.isRequired,
  fetchRanking: PropTypes.func.isRequired,
  changeAnswerChoice: PropTypes.func.isRequired,
  updateAnswerChoice: PropTypes.func.isRequired,
  // props
  isContainerPage: PropTypes.bool
}

PresentationControllerPage.defaultProps = {
  index: 0,
  phase: QuizPhase.PREPARE,
  type: QuizType.NOTIFICATION.value
}

const mapStateToProps = state => ({
  phase: state.presentation.phase,
  index: state.presentation.index,
  type: state.presentation.type,
  isLoading: state.presentation.isControllerLoading,
  project: state.presentation.project,
  ranking: state.presentation.ranking,
  isRankingFetching: state.presentation.isRankingFetching,
  isRankingFetched: state.presentation.isRankingFetched
})

const mapDispatchToProps = dispatch => ({
  fetchProject: env => dispatch(FETCH_PROJECT(env)),
  fetchRanking: data => dispatch(FETCH_RANKING(data)),
  waitWebsocket: () => dispatch(WAIT_WEBSOCKET()),
  recieveChangeStatus: status => dispatch(RECEIVE_CHANGE_STATUS(status)),
  changeAnswerChoice: e => dispatch(CHANGE_REALTIME_ANSWER_CHOICE(e)),
  updateAnswerChoice: () => dispatch(UPDATE_REALTIME_ANSWER_CHOICE())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PresentationControllerPage)
